<div class="row">
    <div class="col-md-12">
        <div *ngIf="canPurchase">
            <p>Select {{ selectChildTermName$ | async | lowercase }} account(s) to buy product for:</p>
            <form
                name="child-accounts-form"
                [formGroup]="childAccountsForm"
            >
                <table class="table table-hover table-striped">
                    <thead>
                        <tr>
                            <th>
                                <input
                                    name="selectAll"
                                    type="checkbox"
                                    (click)="toggleSelectAll($event)"
                                /> Select All
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let account of childAccounts">
                            <td>
                                <input
                                    type="checkbox"
                                    (change)="onSelect($event)"
                                    [value]="account.userAccountId"
                                    name="userAccountId"
                                    [checked]="selectAllCheckbox"
                                    [disabled]="selectAllCheckbox"
                                />
                                <strong> {{account.fullName}}</strong>{{account.email}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </div>
        <br />
        <div class="pull-right">
            <button
                type="button"
                class="btn btn-primary m-1"
                *ngIf="canPurchase"
                name="confirmationYesBtn"
                (click)="batchAddItem()"
                [disabled]="selectedChildAccountsIds.length===0"
            >
                <i class="fa fa-shopping-cart"></i>
                Add {{selectedChildAccountsIds.length}} item(s) to cart
            </button>
            <a
                (click)="continueShopping()"
                class="btn btn-primary m-1"
            >
                Continue shopping
            </a>
        </div>
    </div>
</div>
